module.exports = __webpack_public_path__ + "static/media/ic_accept.f4d36396.svg";